import { render, staticRenderFns } from "./CourseRatingsList.vue?vue&type=template&id=7eca8a2d&scoped=true&"
import script from "./CourseRatingsList.vue?vue&type=script&lang=js&"
export * from "./CourseRatingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eca8a2d",
  null
  
)

export default component.exports